
import React, { useEffect, useRef, useState } from 'react'
import {  storage } from '../../firebase'
import { getDownloadURL, uploadBytes, ref as sRef, uploadString, uploadBytesResumable } from 'firebase/storage'
import { Link } from 'react-router-dom'
import Papa from 'papaparse';
import axios from 'axios'
import {getAllUsers, getUsersWithRel} from '../../api/user'
import { snakeToCamel } from './AdminEditRelease';
import { getAllReleases, getReleases } from '../../api/releases'
import { createReports } from '../../api/reports'
import { useQueries, useQuery } from '@tanstack/react-query'
import { report_overviews } from '../../utils/report_overview'
import { validateTheUpload } from '../../utils/validate_report_and_overview'
import useProgressStore from '../../store/progressStore'

const AdminReports = () => {
    const { 
        setActive, 
        setValidating, 
        setSubmitting, 
        setUploadProgress, 
        setUpdateProgress, 
        setValidationMessage, 
        setSubmissionMessage,
        completeOperation,
        isValidating,
        isSubmitting,
        validationMessage,
        submissionMessage
    } = useProgressStore()
    const uid = localStorage.getItem('uid');
    const [reportsUploadSuccess, setReportsUploadSuccess] = useState(false)
    const [reportsUpdateSuccess, setReportsUpdateSuccess] = useState(false)
    const [users, setUsers] = useState([])
    const [uploadReportsMessage, setUploadReportsMessage] = useState('Upload Reports')
    const [fileUpload, setFileUpload] = useState({})
    const [fileReports, setFileReports] = useState([])
    const [fileHeaders, setFileHeaders] = useState([])
    const [dropdowns, setDropdowns] = useState(false)
    const [overviewObjects, setOverviewObjects] = useState([])
    const [reports, setReports] = useState([])
    const [reportOverview, setReportOverview] = useState({})
    const [reportURL, setReportURL] = useState('')
    const [errors, setErrors] = useState([])
    const [validationErrors, setValidationErrors] = useState({
        missingReleases: [],
        missingTracks: [],
        wasnotLive: []
    })
    const [dropVerify, setDropVerify] = useState(true)
    const reportsSuccess = useRef()
    const errorBtn = useRef()

    const [headers, setHeaders] = useState([
        {
            title: 'Statement Period',
            mapping: 'Statement Period',
            uploaded: ''
        },
        {
            title: 'Transaction Month',
            mapping: 'Transaction Month',
            uploaded: ''
        },
        {
            title: 'Artist',
            mapping: 'Artist',
            uploaded: ''
        },
        {
            title: 'Label',
            mapping: 'Label',
            uploaded: ''
        },
        {
            title: 'Platform',
            mapping: 'Platform',
            uploaded: ''
        },
        {
            title: 'Release Title',
            mapping: 'Release Title',
            uploaded: ''
        },
        {
            title: 'Track Title',
            mapping: 'Track Title',
            uploaded: ''
        },
        {
            title: 'UPC',
            mapping: 'UPC',
            uploaded: ''
        },
        {
            title: 'ISRC',
            mapping: 'ISRC',
            uploaded: ''
        },
        {
            title: 'Units',
            mapping: 'Quantity',
            uploaded: ''
        },
        {
            title: 'Payee ID',
            mapping: 'Payee ID',
            uploaded: ''
        },
        {
            title: 'Sale Type',
            mapping: 'Sale Type',
            uploaded: ''
        },
        {
            title: 'Territory',
            mapping: 'Territory',
            uploaded: ''
        },
        {
            title: 'Earnings',
            mapping: 'Earnings',
            uploaded: ''
        }
    ])

    const {data: dbUser, isLoading: user_loading, error: userError} = useQuery({
        queryKey: ['users_with_all'],
        queryFn: async ()=> await getUsersWithRel(),
    }) 

    const {data: releasesData, isLoading: releases_loading} = useQuery({
        queryKey: ['releases'],
        queryFn: async () => await getAllReleases(),
      
    })

    useEffect(() => {
        const userInfo = async () => {
            const usersI = await getAllUsers();
            setUsers(snakeToCamel(usersI))
        }
        userInfo()
    }, [])
   
    const updateReports = async () => {    
     
            setSubmitting(true);
            setSubmissionMessage('Submitting reports...');
            setActive(true);
            uploadReportsToFirebase(reports, reports[0]['Statement Period']);
            
    }


    const handleOverview = async (reports) => {
        if(!user_loading){
            try {
                const data = report_overviews(reports, dbUser)
                setOverviewObjects(data)
                setDropdowns(false)
            } catch (error) {
                console.error('Error generating overview:', error);
                setErrors(prev => [...prev, 'Error generating overview. Please try again.']);
                errorBtn.current.click();
            }
        } 
    }
    


    useEffect(() => {
        if (reportsUploadSuccess === true && reportsUpdateSuccess === true) {
            setActive(false)
            reportsSuccess.current.click()
        }
    }, [reportsUploadSuccess, reportsUpdateSuccess])

    const handleAppear = (properties) => {
        headers.map((item, i) => {
            const existingHeader = properties.find(property => property === item.mapping)
            if (existingHeader) {
                handleMapp(existingHeader, i)
            } else {
                handleMapp('Select Header', i)
            }
            setUploadReportsMessage('Upload Reports')
        })
    }

    const handleReportsUpload = (event) => {
        const file = event.target.files[0];
        setFileUpload(file)
        setUploadReportsMessage('Please Wait...')
        setDropdowns(true)
        
        // Show progress indicator while parsing the file
        setActive(true);
        setValidating(true);
        setValidationMessage('Reading file contents...');
        
        if (file) {
            Papa.parse(file, {
                complete: (result) => {
                    setFileReports(result.data)
                    const properties = Object.keys(result.data[0])
                    setFileHeaders(properties)
                    handleAppear(properties)
                    
                    // Update progress status
                    setValidating(false);
                    setActive(false);
                },
                header: true, // Set this to true if your CSV file has a header row
                error: (error) => {
                    console.error('Error parsing CSV:', error);
                    setErrors(prev => [...prev, 'An error occurred while parsing the CSV file. Please check the file format.']);
                    errorBtn.current.click();
                    setValidating(false);
                    setActive(false);
                }
            });
        }
    }

    const handleMapp = (header, index) => {
        let newHeaders = [...headers]
        newHeaders[index].uploaded = header
        setHeaders(newHeaders)
    }

      
    // Function to upload CSV file to Firebase Storage

      

    const validateFile = async (data) => {
        try {
            setValidating(true);
            setValidationMessage('Validating your file...');
            
            let count = 0;
            let hasErrors = false;
            setErrors([]);
            
            // Basic validation
            data.forEach((item, i) => {
                count++;
            
                if (item['UPC'] === undefined || item['UPC'] === '') {
                    setErrors((prevErrors) => [...prevErrors, `Missing UPC in row ${i + 2}`]);
                    hasErrors = true;
                }
                if (item['Quantity'] === undefined || item['Quantity'] === '') {
                    setErrors((prevErrors) => [...prevErrors, `Missing units in row ${i + 2}`]);
                    hasErrors = true;
                }
                if (item['Earnings'] === undefined || item['Earnings'] === '') {
                    setErrors((prevErrors) => [...prevErrors, `Missing revenue in row ${i + 2}`]);
                    hasErrors = true;
                }
            });
            
            // Advanced validation using validateTheUpload
            if (!hasErrors && !releases_loading) {
                setValidationMessage('Performing advanced validation...');
                // Extract all tracks from releases
                console.log(releasesData, "releasesData")
                const allTracks = releasesData.releases.flatMap(release => release.tracks || []);
                console.log(allTracks, "allTracks")
                
                // Call validateTheUpload
                const validationResult = await validateTheUpload(data, releasesData.releases, allTracks);
                
                // Check if there are any validation errors
                if (validationResult.missingReleases.size > 0 || 
                    validationResult.missingTracks.size > 0 || 
                    validationResult.wasnotLive.size > 0) {
                    
                    // Convert Sets to Arrays for easier rendering
                    setValidationErrors({
                        missingReleases: Array.from(validationResult.missingReleases),
                        missingTracks: Array.from(validationResult.missingTracks),
                        wasnotLive: Array.from(validationResult.wasnotLive)
                    });
                    
                    hasErrors = true;
                    setValidationMessage('Validation completed with errors');
                    errorBtn.current.click();
                } else {
                    // No validation errors, proceed with overview
                    setValidationMessage('Validation successful!');
                    handleOverview(data);
                }
            } else if (!hasErrors) {
                setValidationMessage('Basic validation successful!');
                handleOverview(data);            
            } else {
                // Click the errorBtn if there are basic errors
                setValidationMessage('Validation failed');
                errorBtn.current.click();
            }
        } catch (error) {
            console.error('Error during validation:', error);
            setErrors(prev => [...prev, 'An unexpected error occurred during validation. Please try again.']);
            setValidationMessage('Validation failed');
            errorBtn.current.click();
        } finally {
            setValidating(false);
        }
    };

    const updateHeaders = async () => {
        try {
            setValidating(true);
            setValidationMessage('Updating headers...');
            
            const updatedDataArray = fileReports.map(dataObject => {
                const updatedObject = {};
                headers.forEach(header => {
                  const { mapping, uploaded } = header;
                  updatedObject[mapping] = dataObject[uploaded];
                });
                return updatedObject;
            });
            
            validateFile(updatedDataArray);
            setReports(updatedDataArray);
        } catch (error) {
            console.error('Error updating headers:', error);
            setErrors(prev => [...prev, 'An error occurred while updating headers. Please try again.']);
            setValidating(false);
            errorBtn.current.click();
        }
    }
    
    useEffect(() => {
        if(reports && !user_loading){
            handleOverview(reports)
        }
    },[reports, user_loading])
  const hasEmptyHeaders = headers.find(item => item.uploaded === 'Select Header')
  const resetUploadStates = () => {
        setErrors([]);
        setValidationErrors({
            missingReleases: [],
            missingTracks: [],
            wasnotLive: []
        });
        setFileUpload({});
        setFileReports([]);
        setFileHeaders([]);
        setDropdowns(false);
        setOverviewObjects([]);
        setReports([]);
        setUploadReportsMessage('Upload Reports');
        setActive(false);
        setValidating(false);
        setSubmitting(false);
        
        // Reset header mappings
        let newHeaders = [...headers];
        newHeaders.forEach((header, index) => {
            newHeaders[index].uploaded = '';
        });
        setHeaders(newHeaders);
        // refresh the page
        window.location.reload();
    };
    async function uploadReportsToFirebase(reports, monthYear) {
        const fileName = `${monthYear}.json`;
        const jsonData = JSON.stringify(reports, null, 2);
        const jsonBlob = new Blob([jsonData], { type: 'application/json' });
        const fileRef = sRef(storage, `to_be_processed/${fileName}`);
      
        try {
            const uploadTask = uploadBytesResumable(fileRef, jsonBlob);
            uploadTask.on('state_changed', 
                (snapshot) => {
                    // Get progress percentage
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setUpdateProgress(progress)
                }, 
                (error) => {
                    // Handle unsuccessful uploads
                    console.error('Error uploading JSON to Firebase Storage:', error);
                }, 
                () => {
                    // Handle successful uploads
                    getDownloadURL(fileRef)
                    .then(async (url) => {
                        console.log('File available at', url);
                        // You can store the URL in state if needed
                        // setFileUrl(url);
                        
                        // Or use the URL for other purposes like updating database references
                        console.log(url, "url for the file generated")
                        await createReports(url,uid);
                        setReportsUpdateSuccess(true);
                        setSubmissionMessage('Reports submitted successfully!');
                        completeOperation();
                        setSubmitting(false);
                        reportsSuccess.current.click();
                    })
                    .catch((error) => {
                        setSubmitting(false);
                        console.error('Error getting download URL:', error);
                    });
                }
            );
        } catch (error) {
          console.error('Error uploading JSON to Firebase Storage:', error);
        }
    }
    const resetUploadState = () => {
        setReportsUploadSuccess(false);
        setReportsUpdateSuccess(false);
        setUploadReportsMessage('Upload Reports');
        setFileUpload({});
        setFileReports([]);
        setFileHeaders([]);
        setDropdowns(false);
        setOverviewObjects([]);
        setReports([]);
        setReportOverview({});
        setReportURL('');
        setErrors([]);
        setValidationErrors({
            missingReleases: [],
            missingTracks: [],
            wasnotLive: []
        });
        setDropVerify(true);
    };
  return (
    <div className="admin-page py-5">
        <div className='container'>
            <h1 className='dash-title'>Upload Reports</h1>
            <div className="row">
                <div className="col-lg-4 px-1 mt-4">
                    <div className="dash-form-file py-4">
                        <i className="fi fi-rr-cloud-upload"></i>
                        {uploadReportsMessage}
                        <input 
                            type="file" 
                            onChange={handleReportsUpload} 
                            disabled={releases_loading}
                        />
                        {releases_loading && (
                            <span className="text-muted ms-2 small">(Loading releases...)</span>
                        )}
                        <button data-bs-toggle="modal" data-bs-target="#reportsModal" ref={reportsSuccess} hidden></button>
                    </div>
                </div>
                
                <div className="col-lg-8 px-1 mt-4"></div>
                {
                    dropdowns && (
                        <>
                            <div className="col-12 mt-4">
                                {
                                    headers.map((item, i) => (
                                        <div className="row" key={i}>
                                            <div className="col-md-6 mb-2 px-1">
                                                <h6 className='mapping-base'>{item.title}</h6>
                                            </div>
                                            <div className="col-md-6 mb-2 px-1">
                                                <div className="dropdown dash-form-dropdown">
                                                    <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        {item.uploaded}
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                        {
                                                            fileHeaders.map((header, index) => (
                                                                <li key={index} onClick={() => handleMapp(header, i)}>{header}</li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                                <div className="row">
                                    <div className="col-12 px-1 d-flex justify-content-end mt-3">
                                        <button 
                                            className={`dash-card-heading-btn ${hasEmptyHeaders && 'disabled'}`} 
                                            disabled={hasEmptyHeaders ? true : false || isValidating}
                                            onClick={() => {
                                                updateHeaders()
                                            }}
                                        >
                                            {isValidating ? (
                                                <span>
                                                    <i className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></i>
                                                    {validationMessage}
                                                </span>
                                            ) : (
                                                "Update Headers"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }
                {
                    (!dropdowns) && (
                        <div className="col-12 px-1 mt-4">
                            <h4>Reports Overview</h4>
                            <div className="table-responsive mt-4">
                                <table className="table dash-table">
                                    <thead>
                                        <tr>
                                            <td>Email</td>
                                            <td>Name</td>
                                            <td>Total Streams</td>
                                            <td>Net Revenue</td>
                                            <td>Gross Revenue</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            overviewObjects.map((user, i) => (
                                                <tr key={i}>
                                                    <td>{user.email}</td>
                                                    <td>{user.name}</td>
                                                    <td>{user.totalStreams}</td>
                                                    <td>${user.totalNetRevenue}</td>
                                                    <td>${user.totalGrossRevenue}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-12 px-1 d-flex justify-content-end mt-3">
                                {
                                    errors.length === 0 && overviewObjects.length > 0 && <button 
                                        className='dash-card-heading-btn'
                                        disabled={isSubmitting}
                                        onClick={() => { updateReports();}}
                                    >
                                        {isSubmitting ? (
                                            <span>
                                                <i className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></i>
                                                {submissionMessage}
                                            </span>
                                        ) : (
                                            "Submit"
                                        )}
                                    </button>
                                }
                                {
                                    errors.length > 0 && <button 
                                        className='dash-card-heading-btn'
                                        data-bs-toggle="modal" 
                                        data-bs-target="#errorModal"
                                    >
                                        Submit
                                    </button>
                                }
                            </div>
                        </div>
                    )
                }
            </div>


        </div>




        <div className="modal fade" id="reportsModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="reportsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header bg-success text-white">
                        <h5 className="modal-title" id="reportsModalLabel">
                            <i className="fi fi-rr-check-circle me-2"></i>
                            Success
                        </h5>
                        <button 
                            type="button"
                            className="btn-close btn-close-white"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body success-modal text-center py-4">
                        <i className="fi fi-rr-check-circle text-success success-icon" style={{ fontSize: '4rem', marginBottom: '1rem' }}></i>
                        <h5 className="mb-3">Reports Uploaded Successfully!</h5>
                        <p className="text-muted mb-4">
                            All your reports have been uploaded to the system successfully and are now being processed, we will notify you once the process finished processing.
                        </p>
                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-success me-2"
                                onClick={() => {
                                    resetUploadState();
                                }}
                                data-bs-dismiss="modal"
                            >
                                <i className="fi fi-rr-refresh me-1"></i>
                                Upload More Reports
                            </button>
                            <Link to="/admin/dashboard" className="btn btn-outline-secondary" data-bs-dismiss="modal">
                                <i className="fi fi-rr-dashboard me-1"></i>
                                Go to Dashboard
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button data-bs-toggle="modal" data-bs-target="#errorModal" ref={errorBtn} hidden></button>
        <div className="modal fade" id="errorModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="errorModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header bg-danger text-white">
                        <h5 className="modal-title" id="errorModalLabel">
                            <i className="fi fi-rr-exclamation me-2"></i>
                            Validation Issues Found
                        </h5>
                        <button 
                            type="button"
                            className='btn-close btn-close-white'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body success-modal pb-3">
                        <div className="error-container" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            {validationMessage && (
                                <div className="alert alert-info mb-3">
                                    <i className="fi fi-rr-info-circle me-2"></i>
                                    <strong>Validation Status:</strong> {validationMessage}
                                </div>
                            )}
                            
                            {
                                errors.length > 0 && (
                                    <div className="error-section mb-3" style={{ borderLeft: '4px solid #dc3545', padding: '10px 15px', backgroundColor: '#f8d7da', borderRadius: '4px', marginBottom: '15px' }}>
                                        <h5 className="error-title" style={{ fontWeight: 'bold', color: '#721c24' }}>
                                            <i className="fi fi-rr-exclamation-triangle me-2"></i>
                                            Basic Validation Errors:
                                        </h5>
                                        <div className="alert alert-danger p-2">
                                            <p className="mb-2 small">The following errors were found in your file:</p>
                                            <ul className="mb-0 ps-3">
                                                {errors.map((item, i) => (
                                                    <li key={i} style={{ marginBottom: '5px', fontSize: '14px' }}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                validationErrors.missingReleases.length > 0 && (
                                    <div className="error-section mb-3" style={{ borderLeft: '4px solid #dc3545', padding: '10px 15px', backgroundColor: '#f8d7da', borderRadius: '4px', marginBottom: '15px' }}>
                                        <h5 className="error-title text-danger" style={{ fontWeight: 'bold', color: '#721c24' }}>
                                            <i className="fi fi-rr-file-xmark me-2"></i>
                                            Missing Releases:
                                        </h5>
                                        <p className="error-description" style={{ fontSize: '14px', marginBottom: '10px' }}>
                                            The following UPCs do not match any release in our system. Please check that the UPCs are correct.
                                        </p>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                            {validationErrors.missingReleases.map((upc, i) => (
                                                <div key={i} style={{ backgroundColor: '#f1aeb5', padding: '5px 10px', borderRadius: '20px', fontSize: '13px' }}>
                                                    UPC: {upc}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            }
                            {
                                validationErrors.missingTracks.length > 0 && (
                                    <div className="error-section mb-3" style={{ borderLeft: '4px solid #dc3545', padding: '10px 15px', backgroundColor: '#f8d7da', borderRadius: '4px', marginBottom: '15px' }}>
                                        <h5 className="error-title text-danger" style={{ fontWeight: 'bold', color: '#721c24' }}>
                                            <i className="fi fi-rr-music-alt me-2"></i>
                                            Missing Tracks:
                                        </h5>
                                        <p className="error-description" style={{ fontSize: '14px', marginBottom: '10px' }}>
                                            The following ISRCs do not match any track in our system. Please verify the ISRCs are correct.
                                        </p>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                            {validationErrors.missingTracks.map((isrc, i) => (
                                                <div key={i} style={{ backgroundColor: '#f1aeb5', padding: '5px 10px', borderRadius: '20px', fontSize: '13px' }}>
                                                    ISRC: {isrc}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            }
                            {
                                validationErrors.wasnotLive.length > 0 && (
                                    <div className="error-section mb-3" style={{ borderLeft: '4px solid #ffc107', padding: '10px 15px', backgroundColor: '#fff3cd', borderRadius: '4px', marginBottom: '15px' }}>
                                        <h5 className="error-title text-warning" style={{ fontWeight: 'bold', color: '#856404' }}>
                                            <i className="fi fi-rr-ban me-2"></i>
                                            Not distributed Releases:
                                        </h5>
                                        <p className="error-description" style={{ fontSize: '14px', marginBottom: '10px' }}>
                                            The following releases are not marked as distributed in our system. These releases may not be ready for reporting.
                                        </p>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                            {validationErrors.wasnotLive.map((upc, i) => (
                                                <div key={i} style={{ backgroundColor: '#ffe69c', padding: '5px 10px', borderRadius: '20px', fontSize: '13px' }}>
                                                    UPC: {upc}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        {(errors.length > 0 || validationErrors.missingReleases.length > 0 || 
                          validationErrors.missingTracks.length > 0 || validationErrors.wasnotLive.length > 0) && (
                            <div className="text-center mt-3">
                                <button 
                                    className="btn btn-danger me-2" 
                                    style={{ color: 'white', padding: '8px 20px', borderRadius: '4px', textDecoration: 'none' }}
                                    onClick={() => {
                                        resetUploadStates();
                                    }}
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="fi fi-rr-refresh me-1"></i>
                                    Try Again
                                </button>
                                <button 
                                    className="btn btn-secondary me-2" 
                                    style={{ color: 'white', padding: '8px 20px', borderRadius: '4px', textDecoration: 'none' }}
                                    data-bs-dismiss="modal"
                                aria-label="Close"
                                >
                                    <i className="fi fi-rr-check me-1"></i>
                                    Continue By Ignoring those rows
                                </button>
                            </div>
                            
                        )}
                    </div>
                </div>
            </div>
        </div>

    </div>
  )
}

export default AdminReports